// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/feature/hotel/provider_info.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_duration } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file proto/model/feature/hotel/provider_info.proto.
 */
export const file_proto_model_feature_hotel_provider_info = /*@__PURE__*/
  fileDesc("Ci1wcm90by9tb2RlbC9mZWF0dXJlL2hvdGVsL3Byb3ZpZGVyX2luZm8ucHJvdG8SBmNhcm1lbiKcBQoMUHJvdmlkZXJJbmZvEhUKDXByb3ZpZGVyX25hbWUYASABKAkSGQoRcHJvdmlkZXJfaG90ZWxfaWQYAiABKAkSPwoMY2FwYWJpbGl0aWVzGAMgASgLMikuY2FybWVuLlByb3ZpZGVySW5mby5Qcm92aWRlckNhcGFiaWxpdGllcxJFChFwcm92aWRlcl9tZXRhZGF0YRgEIAMoCzIqLmNhcm1lbi5Qcm92aWRlckluZm8uUHJvdmlkZXJNZXRhZGF0YUVudHJ5Ej4KDGJvb2tpbmdfaW5mbxgFIAEoCzIoLmNhcm1lbi5Qcm92aWRlckluZm8uUHJvdmlkZXJCb29raW5nSW5mbxrgAQoUUHJvdmlkZXJDYXBhYmlsaXRpZXMSFgoOc3VwcG9ydHNfaG9sZHMYASABKAgSIQoZc3VwcG9ydHNfcGFydGlhbF9wYXltZW50cxgCIAEoCBIeChZzdXBwb3J0c19tb2RpZmljYXRpb25zGAMgASgIEh0KFXN1cHBvcnRzX2NhbmNlbGxhdGlvbhgEIAEoCBIcChRzdXBwb3J0ZWRfY3VycmVuY2llcxgFIAMoCRIwCg1tYXhfaG9sZF90aW1lGAYgASgLMhkuZ29vZ2xlLnByb3RvYnVmLkR1cmF0aW9uGnYKE1Byb3ZpZGVyQm9va2luZ0luZm8SEwoLYm9va2luZ191cmwYASABKAkSGQoRYm9va2luZ19yZWZlcmVuY2UYAiABKAkSGAoQbW9iaWxlX2RlZXBfbGluaxgDIAEoCRIVCg1ib29raW5nX3Bob25lGAQgASgJGjcKFVByb3ZpZGVyTWV0YWRhdGFFbnRyeRILCgNrZXkYASABKAkSDQoFdmFsdWUYAiABKAk6AjgBQjZaNGdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsL2ZlYXR1cmUvaG90ZWxiBnByb3RvMw", [file_google_protobuf_duration]);

/**
 * Describes the message carmen.ProviderInfo.
 * Use `create(ProviderInfoSchema)` to create a new message.
 */
export const ProviderInfoSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_provider_info, 0);

/**
 * Describes the message carmen.ProviderInfo.ProviderCapabilities.
 * Use `create(ProviderInfo_ProviderCapabilitiesSchema)` to create a new message.
 */
export const ProviderInfo_ProviderCapabilitiesSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_provider_info, 0, 0);

/**
 * Describes the message carmen.ProviderInfo.ProviderBookingInfo.
 * Use `create(ProviderInfo_ProviderBookingInfoSchema)` to create a new message.
 */
export const ProviderInfo_ProviderBookingInfoSchema = /*@__PURE__*/
  messageDesc(file_proto_model_feature_hotel_provider_info, 0, 1);

